import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { DropdownOption } from '@app/storybook/components/dropdown/dropdown.component';
import { GlobalSettingsFormShape } from '../../../../components/smart-cart-form-global-settings/global-settings.model';
import { GoalFormShape, GoalsProgressBarFormShape, buildGoalGroup } from '../../goals-progress-bar.model';

@Component({
  selector: 'smart-cart-goals-tab',
  templateUrl: './goals-tab.component.html',
  styleUrls: ['../../../../components/shared.scss'],
  standalone: false,
})
export class SmartCartGoalsTabComponent implements OnInit {
  @Input({ required: true }) formGroup!: FormGroup<GoalsProgressBarFormShape>;
  @Input({ required: true }) globalSettingsFormGroup!: FormGroup<GlobalSettingsFormShape>;
  @Input() smartCartId: number | null = null;
  @Input() usageToken = '';

  readonly paddingOptions: DropdownOption[] = [
    { label: 'None', value: 'none' },
    { label: 'Small', value: 'small' },
    { label: 'Medium', value: 'medium' },
    { label: 'Large', value: 'large' },
  ];

  appearanceCollapsed = false;
  goalsArray!: FormArray<FormGroup<GoalFormShape>>;

  ngOnInit(): void {
    this.goalsArray = this.formGroup.controls.goals;
  }

  toggleAppearanceCollapsed(): void {
    this.appearanceCollapsed = !this.appearanceCollapsed;
  }

  addGoal(): void {
    this.goalsArray.push(buildGoalGroup(undefined, this.formGroup.controls.minimumThresholdType.value));
  }

  removeGoal(index: number): void {
    this.goalsArray.removeAt(index);
  }
}
